import React from 'react'
import { DataGrid, GridColDef, GridSlotsComponent } from '@mui/x-data-grid'
import { Stack } from '@mui/material'
import { Row } from './supplierPageConstants'
import { Body1 } from '../../../components/Typography'

function EmptyRow() {
  return (
    <Stack height='100%' alignItems='center' justifyContent='center'>
      <Body1>Inga resultat</Body1>
    </Stack>
  )
}

export function SupplierPageDataGrid(params: {
  gridKey?: React.Key
  loading: boolean
  coldefs: GridColDef<Row>[]
  rows: Row[]
  NoSearchResult: GridSlotsComponent['noResultsOverlay']
}): React.JSX.Element {
  const { gridKey, loading, coldefs, rows, NoSearchResult } = params

  return (
    <DataGrid<Row>
      // A DataGrid assumes the column definitions is the same object
      // for its entire lifetime. This is not compatible with us
      // having different `name` values in the columns, so we set the `key`
      // here in order to re-render the DataGrid when the column definitions
      // change. Without using `key` when chaning the column defs, the grid will
      //  behave weirdly, for example using the wrong column size for the layout.
      key={gridKey}
      loading={loading}
      style={{
        width: '100%',
      }}
      // Note: `autoHeight` is deprecated, but MUIs suggested fix of
      // wrapping the DataGrid in a flex container does not work for empty rows as
      // the empty row is treated as having no height.
      // See: https://mui.com/x/react-data-grid/layout/#flex-parent-container
      autoHeight
      rows={rows}
      columns={coldefs}
      initialState={{
        pagination: {
          paginationModel: {
            page: 0,
            pageSize: 10,
          },
        },
      }}
      pageSizeOptions={[10, 20, 50, 100]}
      slots={{
        noRowsOverlay: EmptyRow,
        noResultsOverlay: NoSearchResult,
      }}
    />
  )
}
